import { useMemo } from "react"
import ObjectDetailPartLeftList from "./ObjectDetailPartLeftList"
import ObjectTourTasksPanel from "../../components/ObjectTourTasksPanel"
import BaseSection from "../../../../components/elements/BaseSection"
import { P } from "../../../../auth/permissions"
import { Authorized } from "../../../../components/authentication/Authorized"

type ObjectDetailPartLeftType = {
    id?: string
    objectAdress: string
    customerId: string
    customerOfObject: string
    objectsOffer: {
        nr: string | number | undefined
        _id: string
    }[]
    objectsBill: {
        nr: string | number | undefined
        billType: string
        _id: string
    }[]
}

export default function ObjectDetailPartLeft(props: ObjectDetailPartLeftType) {
    const urlParams = useMemo(() => {
        return {
            oid: props.id ?? "",
            adress: props.objectAdress,
            cid: props.customerId,
            customer: props.customerOfObject,
        }
    }, [props.id, props.customerId, props.objectAdress, props.customerOfObject])

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">
            <Authorized allOf={[P.objekte_read_write, P.buchhaltung_read]}>
                {props.id && (
                    <BaseSection classProps="!grow">
                        <ObjectTourTasksPanel objectId={props.id} />
                    </BaseSection>
                )}
                <div className="flex flex-col gap-4 min-w-0">
                    <BaseSection classProps="!grow">
                        <ObjectDetailPartLeftList
                            headline="Angebote"
                            singular="Angebot"
                            newtext="Neues Angebot"
                            link="/buchhaltung/angebote/"
                            linknew={`/buchhaltung/angebote?${new URLSearchParams(urlParams).toString()}`}
                            objectListItems={props.objectsOffer}
                        />
                    </BaseSection>
                    <BaseSection classProps="!grow">
                        <ObjectDetailPartLeftList
                            headline="Rechnungen"
                            newtext="Neue Rechnung"
                            link="/buchhaltung/rechnung/"
                            linknew={`/buchhaltung/rechnungen?${new URLSearchParams(urlParams).toString()}`}
                            objectListItems={props.objectsBill}
                        />
                    </BaseSection>
                </div>
            </Authorized>
        </div>
    )
}
